import { render, staticRenderFns } from "./ModelPdf.vue?vue&type=template&id=351f982f&"
import script from "./ModelPdf.vue?vue&type=script&lang=js&"
export * from "./ModelPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports